import Layout from "../layouts/LayoutDefault.jsx";
import ContentContainer from "../components/ContentContainer";
import MainContainer from "../components/MainContainer";
import SmallTitleText from "../components/SmallTitleText";
import CreateEventForm from "../components/loggedin/CreateEventForm";

const addAndEditEvent = () => {
  return (
    <>
      <Layout
        title="Skapa evenemang"
        description="Skapa ett evenemang för ditt band eller musikprojekt"
      >
        <MainContainer>
          <ContentContainer>
            <div className="flex justify-between">
              <SmallTitleText text="Skapa evenemang" />
              <a href="/userprofile">
                <button className="btn btn-neutral border border-base-content/20">
                  Tillbaka
                </button>
              </a>
            </div>

            <p className="my-4 max-w-2xl">
              Välj det musikprojekt som evenemanget ska bli publicerat av.
              <br />
              <br /> Fyll i information om evenemanget som{" "}
              <span className="font-bold">namn</span>,{" "}
              <span className="font-bold">datum</span>,{" "}
              <span className="font-bold">plats</span> och{" "}
              <span className="font-bold">beskrivning</span>.
              <br />
              <br /> Du kan formatera beskrivningen med verktygen i editorn.
            </p>
            <div className="bg-base-200 border border-base-content/20 rounded-lg p-2 mt-2">
              <CreateEventForm />
            </div>
          </ContentContainer>
        </MainContainer>
      </Layout>
    </>
  );
};

export default addAndEditEvent;
